export default function ({ redirect }) {
  redirect(process.env.BASE_NETWORK_URL)
}
